import { FunctionalComponent } from 'vue';
import { AntdIconProps } from '@ant-design/icons-vue/lib/components/AntdIcon';

import { RouterEnum } from '@interface/public';

//----- 枚举 Start -----//
export enum MenuEnum { // 菜单类型
  Default, // 默认
  Doc, // 文档
  Book// 白皮书
}

//----- 枚举 Start -----//

//----- 字典 Start -----//
//----- 字典 End -----//

//----- 接口 Start -----//
export interface LinkInterface { // 链接
  name: string;
  href?: string;
  native?: boolean;
  hash?: string;
  click?: Function;
  icon?: string;
}

export interface MenuInterface extends LinkInterface { // 菜单
  type?: MenuEnum;
  point?: boolean;
  children?: MenuInterface[];
}

export interface BreadcrumbInterface { // 面包屑
  icon: FunctionalComponent<AntdIconProps>;
  name: string;
  href?: RouterEnum;
}

//----- 接口 End -----//
